import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';

import useMailboxService from 'src/modules/mailer/hooks/useMailboxService';
import {
    getAttachmentFilename,
    getAttachmentId,
    getMessageBodyHtml,
    parseFilenameFromDisposition,
    saveBlobAsFile,
    splitMessageAttachments,
} from '../../../helpers';

const asBlob = (result) => {
    if (result?.blob instanceof Blob) {
        return result.blob;
    }

    return new Blob([result?.blob], {
        type: result?.contentType || 'application/octet-stream',
    });
};

const useMailboxAttachments = ({
    t,
    message,
}) => {
    const service = useMailboxService();
    const [downloadingId, setDownloadingId] = useState(null);
    const html = getMessageBodyHtml(message);
    const {
        regular,
    } = useMemo(
        () => splitMessageAttachments(message),
        [message]
    );

    const downloadAttachment = async (attachment) => {
        const id = getAttachmentId(attachment);

        if (!id || downloadingId) {
            return;
        }

        setDownloadingId(id);

        try {
            const result = await service.fetchAttachment(id);
            const filename = parseFilenameFromDisposition(
                result.contentDisposition,
                getAttachmentFilename(attachment)
            );

            saveBlobAsFile(asBlob(result), filename);
        } catch (error) {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while downloading the attachment.'), {
                type: 'error',
            });
        } finally {
            setDownloadingId(null);
        }
    };

    return {
        regularAttachments: regular,
        rewrittenHtml: html,
        previewUrls: {},
        downloadAttachment,
        downloadingId,
    };
};

export default useMailboxAttachments;
